import { render, staticRenderFns } from "./ABarcodeOtp.vue?vue&type=template&id=1a246376&"
import script from "./ABarcodeOtp.vue?vue&type=script&lang=js&"
export * from "./ABarcodeOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports